import React from 'react';
import PropTypes from 'prop-types';

import PageContainer from 'shared-components/PageContainer/PageContainer';
import { VIEW_SIZE } from 'utils/device';
import styles from './IntroProductBanner.module.scss';

const IntroProductBanner = ({
  title,
  paragraph,
  backgroundColor,
  desktopImageUrl,
  viewSize,
}) => {
  const mobileDevices =
    viewSize === VIEW_SIZE.small || viewSize === VIEW_SIZE.medium;
  const backgroundStyle = mobileDevices
    ? { backgroundColor }
    : { backgroundImage: `url(${desktopImageUrl})`, backgroundColor };

  return (
    <div className={styles.background} style={backgroundStyle}>
      <PageContainer className={styles.container}>
        <div className={styles.content}>
          <h1>{title}</h1>
          <div
            className={styles.paragraph}
            dangerouslySetInnerHTML={{ __html: paragraph }}
          />
        </div>
      </PageContainer>
    </div>
  );
};

IntroProductBanner.propTypes = {
  title: PropTypes.string.isRequired,
  paragraph: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  desktopImageUrl: PropTypes.string.isRequired,
  viewSize: PropTypes.string.isRequired,
};

export default IntroProductBanner;
